<template>
  <HomeTable v-bind:lines="lines" :loading="loading"></HomeTable>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import KTWidget2 from "@/view/pages/home/Widget2";
import HomeTable from "@/view/pages/home/HomeTable";
import axios from 'axios';
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "home",
  components: {
    // AdvancedTableWidget2
    // KTWidget2,
    HomeTable,
  },  
   data() {
     return {
       loading: false,
       lines: [],
       // Note 'isActive' is left out and will not appear in the rendered table
       fields: [
         {
           key: 'last_name',
           sortable: true
         },
         {
           key: 'first_name',
           sortable: true
         },
         {
           key: 'age',
           label: 'Person age',
           sortable: true,
           // Variant applies to the whole column, including the header and footer
          //  variant: 'warning'
         }
       ]
      }
    },
  mounted() {
    this.$root.$on("BrowserCallBack", () => {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `Home`,
          route: `/`,
        },
      ]);  
    }),
    this.loading = true;
    axios.get('/line/lineitems').then(response => {
        // console.log(response.data);
        this.lines = response.data;
        this.loading = false;
      })
      .catch(err => {
          this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
        throw err
        })
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Home" }]);
  },
  methods: {
  }
};
</script>
